module.exports = __webpack_public_path__ + "json/buildings-12.json?b6f044fd379b526cab7f61fcaf35da11";


//////////////////
// WEBPACK FOOTER
// ./src/assets/packed/buildings/buildings-12.json
// module id = 1718
// module chunks = 3